import {LensIcon} from "../../assets/icons";
import React from "react";
import {useNavigate} from "react-router-dom";
import {Button} from "antd";
import {faRemove} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const SearchBar = () => {

    const navigate = useNavigate();
    const [input, setInput] = React.useState('');
    const [isShow, setIsShow] = React.useState(false);

    const handleKeyDown = (event: any) => {
        if(event.key === 'Enter'){
            navigate('/cabinet/catalog?query=' + input);
            setInput('');
        }
    }

    const onSearch = () => {
        navigate('/cabinet/catalog?query=' + input);
        setInput('');
    }

    return (
        <>
            <button onClick={() => setIsShow(!isShow)}
                className="mobile-searchbar-show btn h-8 w-8 rounded-full p-0 hover:bg-slate-300/20 focus:bg-slate-300/20 active:bg-slate-300/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25 sm:hidden">
                <LensIcon/>
            </button>
            <div id="searchbar-wrapper" className={`hidden${isShow ? ' is-active' : ''} sm:flex`}>
                <div className="relative mr-4 flex h-8">
                    <input
                        id="searchbar-ref"
                        placeholder="Поиск по курсам..."
                        className="form-input peer h-full w-60 mr-2 rounded-full bg-slate-150 px-4 pl-9 text-xs+ text-slate-800 ring-primary/50 hover:bg-slate-200 focus:ring dark:bg-navy-900/90 dark:text-navy-100 dark:placeholder-navy-300 dark:ring-accent/50 dark:hover:bg-navy-900 dark:focus:bg-navy-900"
                        type="text" onChange={(evt) => setInput(evt.target.value)} value={input}
                        onKeyDown={handleKeyDown}
                    />
                    <Button className={'rounded-full'} onClick={onSearch} type={'primary'}>Найти</Button>
                    <button onClick={() => setIsShow(!isShow)}
                            className="btn h-8 rounded-full p-0 hover:bg-slate-300/20 focus:bg-slate-300/20 active:bg-slate-300/25 sm:hidden">
                        <FontAwesomeIcon icon={faRemove}/>
                    </button>
                    <div
                        className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary">
                        <LensIcon/>
                    </div>
                </div>
            </div>
        </>
    )

}

export default SearchBar;
